import { ZodSchema } from 'zod';

import { Logger } from './Logger';

export const schemeParse = <T>(schema: ZodSchema<T>, data: unknown) => {
  const logger = new Logger('SCHEME_PARSE');
  const parsed = schema.safeParse(data);

  if (!parsed.success) {
    logger.logError(parsed.error.message);
    // TODO Sentry
  }

  return parsed;
};

export const schemeParseMultiple = <T>(schema: ZodSchema<T>, data: unknown[]) => {
  return data.reduce<T[]>((acc, item) => {
    const parsed = schemeParse(schema, item);

    if (parsed.success) {
      acc.push(parsed.data);
    }

    return acc;
  }, [] as T[]);
};
